// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__1PXyI","selectItem":"select_selectItem__1jUUk","chip":"select_chip__1Dxnw"};